import {optional} from '@raison/io-ts-tools';
import {TypeOf, number, string, type} from 'io-ts';

export const Payment = type({
    amount: number,
    callback_url: optional(string),
});
export type Payment = TypeOf<typeof Payment>;

export const StripeIntentSchema = type({
    client_secret: string,
    payment_intent: string,
    payment_method: string,
});
export type StripeIntentSchema = TypeOf<typeof StripeIntentSchema>;
